import {createModel} from '~~/package/utils/ModelUtil';
import Model from '~~/package/mapper/Model';
import {
    ProSkillAssureAssessmentBriefSetModel
} from '~~/package/mapper/proSkillAssure/model/assessment/myInfo/ProSkillAssureAssessmentBriefSetModel';
import {
    ProSkillManagerCandidateStatusType
} from '~~/package/mapper/proSkillManager/model/candidate/ProSkillManagerCandidateStatusType';
import {
    ProSkillAssureSampleAssessmentType
} from '~~/package/mapper/proSkillAssure/model/ProSkillAssureSampleAssessmentType';

export class ProSkillAssureAssessmentMyInfoModel extends Model {
    constructor(
        public status: ProSkillManagerCandidateStatusType = ProSkillManagerCandidateStatusType.NONE,
        public organizationName: string = "",
        public assessmentStatus: string = "",
        public assessmentName: string = "",
        public assessmentDescription: string = "",
        public startedAt: number = 0,
        public endedAt: number = 0,
        public questionCount: number = 0,
        public duration: number = 0,
        public availableForTest: boolean = false,
        public customAssessmentBriefSetVOList: ProSkillAssureAssessmentBriefSetModel[] = [],
        public rulesAgreeFlag: boolean = false,
        public isEyeTracking: boolean = false,
        public isTabProctoring: boolean = false,
        public isCopyPasteFlag: boolean = false,
        public isShortcutFlag: boolean = false,
        public isMultiMonitorFlag: boolean = false,
        public isScreenRecordingFlag: boolean = false,
        public leftTimeShorterThanDuration: boolean = false,
        public leftTimeInMin: number = 0,
        public useExternalMonitoringFlag: boolean = false,
        public sampleAssessmentType: ProSkillAssureSampleAssessmentType = ProSkillAssureSampleAssessmentType.CODE,
        public sampleAssessment: boolean = false,
        public sampleAvailable: boolean = true,
        /**
         * REQ-313 1차 QA — 이 응시자에게 [응시 환경 점검]을 적용하는가
         * (`user_map_custom_assessment.use_environment_check_flag`, NOT NULL DEFAULT TRUE).
         *
         * "어떤 점검이 도는가"는 이 값과 감독 유형(isScreenRecordingFlag / useExternalMonitoringFlag)의
         * AND 다 — 그 AND 는 여기(프론트)에서 한다. 서버가 미리 AND 해서 내려주면 "운영이 이 응시자를
         * 예외로 뒀는가"와 "이 평가에 점검 단계가 있는가"가 한 값에 섞인다.
         * 구버전 서버(필드 없음)에서는 기본값 true 로 종전 동작을 유지한다.
         */
        public useEnvironmentCheckFlag: boolean = true,
        /** REQ-313 1차 QA — 이 응시자에게 [모바일·태블릿 차단]을 적용하는가. 기본 적용(true). */
        public useDeviceBlockFlag: boolean = true,
        /**
         * REQ-313 추가 요구사항 — 이 응시자가 감독 미적용으로 응시하는가.
         *
         * 운영이 [응시 환경 점검]을 끄면 서버가 감독 플래그 7개
         * (isEyeTracking / isTabProctoring / isCopyPasteFlag / isShortcutFlag /
         * isMultiMonitorFlag / isScreenRecordingFlag / useExternalMonitoringFlag)를
         * 모두 false 로 내려보낸다. 그래서 화면 분기는 이 값을 읽을 필요가 없다 —
         * 감독 플래그만 보고도 전부 올바르게 꺼진다.
         *
         * 이 값은 진단용이다: 감독 플래그가 전부 false 일 때 그것이 "원래 감독이 없는 평가"인지
         * "운영이 이 응시자만 예외로 뒀는지"를 로그·문의 대응에서 구분하기 위한 것이다.
         * 구버전 서버(필드 없음)에서는 false 로 종전 동작을 유지한다.
         */
        public proctoringExempt: boolean = false,
    ) {
        super();
    }

    public static create(model: Partial<ProSkillAssureAssessmentMyInfoModel>): ProSkillAssureAssessmentMyInfoModel {
        return createModel<ProSkillAssureAssessmentMyInfoModel>(ProSkillAssureAssessmentMyInfoModel, {
            ...model,
            sampleAvailable: model.sampleAvailable ?? true
        });
    }
}
